/**
 * 用户名脱敏
 */
export default function encodeUserName(name) {
  if (!name) {
    return '';
  }
  if (name.length <= 1) {
    return '*';
  }
  if (name.length === 2) {
    return "".concat(name.substring(0, 1), "*");
  }
  if (name.length === 3) {
    return "".concat(name.substring(0, 1), "*").concat(name.substring(2, 3));
  }
  return "".concat(name.substring(0, 1), "**").concat(name.substring(3, name.length));
}
//# sourceMappingURL=encode-user-name.js.map